export default {
  stockItemAlternatives: [],
  stockItemAlternative: undefined,
};
